import { WartungsfensterListItem } from 'app/core/services/api-client';

export interface IStartPageInfoState {
  systemMessageMarkdown: string;
  wartungsfenster: WartungsfensterListItem[];
}

export const initialState: IStartPageInfoState = {
  systemMessageMarkdown: null,
  wartungsfenster: [],
};
